import { useCallback, useState } from 'react'

import { post } from '@/services/download/post'

export const useDownloadPost = () => {
  const [isLoading, setIsLoading] = useState(false)

  const downloadPost = useCallback(
    async ({ idPedidoList }: { idPedidoList: string[] }) => {
      try {
        setIsLoading(true)
        const response = await post(idPedidoList)

        return response
      } catch (error) {
        return error
      } finally {
        setIsLoading(false)
      }
    },
    []
  )

  return { downloadPost, isLoading }
}
